import { getPropertyTypeForTitle } from '../../utils';

export const getPropertyTypeAndCountForTitle = (
  propertyTypeInUrl: string,
  count: number
): string =>
  `${count} ${getPropertyTypeForTitle(propertyTypeInUrl, count !== 1)}`;
